import React, { useEffect, useRef } from 'react';
import './Timeline.scss';
import { Icons } from '../Icons/Icons';
import { useTimelineDrag } from '../../hooks/useTimelineDrag';
import { TimelineEventMarker } from './TimelineEventMarker';
import { calculateEventPosition, calculateDistanceToNext, isEventActive } from '../../utils/timelineUtils';

export interface TimelineEvent {
  year: string;
  title: string;
  img?: string;
  content?: React.ReactNode;
  picName?: string;
  blurhash?: string;
}

interface TimelineProps {
  progress: number;
  events: TimelineEvent[];
  setProgressInThreeJS: (targetProgress: number) => void;
}

const Timeline: React.FC<TimelineProps> = ({ progress, events, setProgressInThreeJS }) => {
  const lineRef = useRef<HTMLDivElement>(null);
  const { isDragging, handleMouseDown } = useTimelineDrag(lineRef, setProgressInThreeJS);

  useEffect(() => {
    const distance = calculateDistanceToNext();
    document.documentElement.style.setProperty('--event-distance', `${distance}vw`);
  }, [events]);

  useEffect(() => {
    document.documentElement.style.setProperty('--gradient-position', `${progress}%`);
  }, [progress]);

  return (
    <div className="timelineContainer">
      <div className="line" ref={lineRef}>
        <div className="circles circles-start">
          {Icons.TimelineCircles}
        </div>
        <div
          className={`dot ${isDragging ? 'dragging' : ''}`}
          style={{ left: `${progress}%` }}
          onMouseDown={handleMouseDown}
        />
        {events.map((event, index) => {
          const position = calculateEventPosition(index);
          const active = isEventActive(progress, index);

          return (
            <TimelineEventMarker
              key={index + event.year + event.title}
              event={event}
              position={position}
              isActive={active}
              index={index}
            />
          );
        })}
        <div className="circles circles-end">
          {Icons.TimelineCircles}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
